module.exports = __webpack_public_path__ + "static/studies-537403487.bd144744.jpg";